import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, Event, NavigationEnd, RouterEvent } from '@angular/router';
import { Subscription, from } from 'rxjs';

import { AuthService } from '../../services/auth.service';
import { DialogService } from '../../common/services/dialog.service';
import { LawService } from '../services/law.service';
import { NavService } from "../services/nav.service";
import { SubHeaderService } from '../../core/services/sub-header.service';
import { RouteStrategy } from "../../core/models/routing.model";

import { HeightWidthService, IHeightWidth } from "../../common/services/height-width.service";
import { LawNavItem } from '../models/models';
import { LunaClaimValues } from '../../models/user-identity.model';
import { SidePanelService } from "../../common/services/side-panel.service";
import { SidePanel, SidePanelLayout } from "../../common/models/side-panel.model";
import { SubHeader } from "../../core/models/sub-header.model";

@Component({
    selector: 'law-library-home',
    templateUrl: './law-library-home.component.html',
    styleUrls: ['./law-library-home.component.scss'],
    standalone: false
})
export class LawLibraryHomeComponent implements OnInit, OnDestroy {
  public activeNavItem: LawNavItem | undefined;
  public lunaClaimValues = LunaClaimValues;
  public _subHeader: SubHeader;
  public _isPhoneBP: boolean = false;        //below 640px screen res?
  public isEditingLaw: boolean = false;

  public navigateSidePanel: SidePanel = new SidePanel({
    tabs: [{ title: "Navigate" }],
    sections: [{ componentName: "LawLibraryNav" }],
    sidePanelLayout: <SidePanelLayout>{ right: false, thin: true, constrainToScrolling: true, forceSingleTab: true, showTabsPhoneOnly: true, hostPadding: false },
    visible: false
  });

  public _routerSub: Subscription;

  constructor(
    public subHeaderService: SubHeaderService,
    public lawService: LawService,
    public dialogService: DialogService,
    public router: Router,
    public sidePanelService: SidePanelService,
    public navService: NavService,
    public heightWidthService: HeightWidthService,
    public _authService: AuthService,
    public _changeDetectorRef: ChangeDetectorRef
  ) {
    //hack to fix another hack in view-dashboard.component.ts that prevents reusing of route. this allows the page
    //to load new data without reloading the page
    this.router.routeReuseStrategy = new RouteStrategy();
  }

  ngOnDestroy(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    if (this._routerSub)
      this._routerSub.unsubscribe();
  }

  ngOnInit() {
    this.sidePanelService.newSidePanel(this.navigateSidePanel);
    this.sidePanelService.toggleSidePanel(true);

    //create "Add New Law" button
    this._subHeader = new SubHeader({ title: "Law Library" });
    if (this._authService.hasSystemPermission(LunaClaimValues.ManageLawLibrary))
      this._subHeader.buttons = [{ name: "Add New Law", method: () => this.addNewLaw() }];

    this.subHeaderService.updateSubHeader(this._subHeader);

    this.navService.getActiveNavItem().subscribe((activeNavItem: LawNavItem | null) => {

      this.activeNavItem = activeNavItem;

      if (!this._changeDetectorRef['destroyed'])
        this._changeDetectorRef.detectChanges();

      //are we at phone resolution?
      if (this._isPhoneBP)
        this.sidePanelService.toggleSidePanel(false);
    });

    //tracks BP on resise
    this.heightWidthService.getHW().subscribe((hw: IHeightWidth) => {
      this._isPhoneBP = hw.isBelowMediumBP;
    });

    //catches direct URL to editing (example page refresh)
    this.setIsEditing(this.router.url);

    //catch for (click event) router changes
    this._routerSub = this.router.events.subscribe((event: Event | RouterEvent) => {
      if (event instanceof NavigationEnd) {
        this.setIsEditing(event.url);
      }
    });
  }

  public setIsEditing(url: string): void {
    this.isEditingLaw = url.indexOf("edit") != -1;
  }

  public addNewLaw(): void {
    this.isEditingLaw = false;
    this.activeNavItem = undefined;
    this.router.navigateByUrl('law-library/create');
  }

  public editLaw(lawId): void {
    this.router.navigateByUrl(`law-library/${lawId}/edit`);
  }

  public deleteFile(): void {
    this.dialogService.openDialog('confirmCancel', `Confirm to delete ${this.activeNavItem.name}`);
  }

  public onDialogConfirm(): void {
    this.dialogService.closeDialog();
    this.lawService.deleteLaw(this.activeNavItem.id).subscribe(() => {
      this.activeNavItem = null;
      this.router.navigate(["law-library"]);
    });
  }

  public onDialogClose(): void {
    this.dialogService.closeDialog();
  }

}
